import React from 'react';
import { Box, IconButton, Typography } from '@mui/material';
import Icon from 'components/Icon';
import { TitleProps } from './types';

const TitleComponent = ({ activeIndex, total, title, handleChange }: any) => {
  const handleClickPrev = () => {
    activeIndex = activeIndex - 1;
    handleChange(activeIndex);
  };
  const handleClickNext = () => {
    activeIndex = activeIndex + 1;
    handleChange(activeIndex);
  };
  return (
    <Box display="flex" alignItems="center">
      <Typography variant="h2">
        {total} {title}
      </Typography>
      <IconButton disabled={activeIndex === 0 ? true : false} onClick={handleClickPrev}>
        <Icon name="arrow-circle-left"></Icon>
      </IconButton>
      <Typography variant="h2">
        {activeIndex + 1}/{total}
      </Typography>
      <IconButton disabled={activeIndex === total - 1 ? true : false} onClick={handleClickNext}>
        <Icon name="arrow-circle-right"></Icon>
      </IconButton>
    </Box>
  );
};

export default TitleComponent;
